export default "__VITE_ASSET__0c8d2546__"